import script from "./FileManagerView.vue?vue&type=script&setup=true&lang=js"
export * from "./FileManagerView.vue?vue&type=script&setup=true&lang=js"

import "./FileManagerView.vue?vue&type=style&index=0&id=f9048676&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9048676"]])

export default __exports__